import { css } from "@emotion/react";
import styled from "@emotion/styled";
import colors from "../../styles/colors";
export const AlertContainer = styled.div `
  ${(props) => getAlertWidth(props.variant)}
  ${(props) => getAlertColor(props.backgroundColor)}
  ${(props) => getIconColor(props.backgroundColor)}
	${(props) => getFontColor(props.backgroundColor)}
	font-family: Inter;
  display: flex;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  position: relative;
  gap: 0.25rem;
  flex: 1 0 0;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.125rem;
  align-items: ${(props) => props.variant === "alert-box-order-form" ? "center" : "flex-start"};
  border-radius: ${(props) => props.variant === "alert-box-order-form" ? "0.25rem" : ""};
  svg {
    ${css `
      height: 1rem; /* Adjust the height as needed */
      width: 1rem; /* Adjust the width as needed */
      /* Define the styles for the SVG elements */
    `}
  }
`;
export const IconContainer = styled.span `
  margin-right: 0.25rem;
  margin-top: 1px;
`;
export const IconTextContainer = styled.div `
  display: flex;
  ${(props) => getAlertBoxAlignment(props.variant)};
  justify-content: ${(props) => props.variant === "alert-box-xsmall" ? "center" : "flex-start"};
  flex-grow: ${(props) => (props.variant === "alert-box-xsmall" ? "1" : "0")};
  margin-top: -2px;
`;
export const TextContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: ${(props) => props.variant === "alert-box-xsmall" ? "center" : "flex-start"};
`;
export const Header = styled.span `
  font-weight: 600;
  margin: 0;
`;
export const Content = styled.span `
  font-weight: 400;
  margin: 0;
`;
export const Time = styled.span `
  font-size: 0.75rem;
  ${(props) => getFontColor(props.backgroundColor)};
  font-weight: 400;
`;
export const CloseIcon = styled.div `
	display: flex;
	align-items: center;
	justify-content: flex-end;
	cursor: pointer;
	svg {
		${css `
      width: 1rem;
      height: 1rem;
    `}
	}
}`;
function getAlertWidth(variant) {
    switch (variant) {
        case "alert-box":
            return css `
        align-items: flex-start;
      `;
        case "alert-box-xsmall":
            return css `
        align-items: center;
        font-width: 0.625rem;
        line-height: 1rem;
        font-weight: 500;
      `;
        case "alert-box-summary-card":
            return css `
        align-items: flex-start;
        width: 27rem;
      `;
        default:
            return css `
        align-items: flex-start;
      `;
    }
}
function getIconColor(color) {
    let iconColor;
    switch (color) {
        case "alert":
            iconColor = colors["color-red-160"];
            break;
        case "warn":
            iconColor = colors["color-gold-160"];
            break;
        case "announcement":
            iconColor = colors["color-blue-180"];
            break;
        case "info":
            iconColor = colors["color-gray-110"];
            break;
        case "review":
            iconColor = colors["color-purple-140"];
            break;
        case "success":
            iconColor = colors["color-green-160"];
            break;
        default:
            iconColor = colors["color-green-160"];
    }
    return css `
    svg {
      ${css `
        /* Define the styles for the SVG elements */
        circle {
          stroke: ${iconColor};
        }
      `}
    }
  `;
}
function getAlertColor(color) {
    let bgColor;
    switch (color) {
        case "alert":
            bgColor = colors["color-red-20"];
            break;
        case "warn":
            bgColor = colors["color-yellow-20"];
            break;
        case "announcement":
            bgColor = colors["color-blue-30"];
            break;
        case "info":
            bgColor = colors["color-gray-20"];
            break;
        case "review":
            bgColor = colors["color-purple-20"];
            break;
        case "success":
            bgColor = colors["color-green-20"];
            break;
        case "gray-dark":
            bgColor = colors["color-gray-30-50p"];
            break;
        default:
            bgColor = colors["color-green-20"];
            break;
    }
    return css `
    background-color: ${bgColor};
    svg {
      ${css `
        /* Define the styles for the SVG elements */
        circle {
          fill: ${bgColor};
        }
      `}
    }
  `;
}
function getFontColor(color) {
    let fontcolor;
    switch (color) {
        case "alert":
            fontcolor = colors["color-red-160"];
            break;
        case "warn":
            fontcolor = colors["color-gold-160"];
            break;
        case "announcement":
            fontcolor = colors["color-blue-160"];
            break;
        case "info":
            fontcolor = colors["color-gray-160"];
            break;
        case "gray-dark":
            fontcolor = colors["color-gray-160"];
            break;
        case "review":
            fontcolor = colors["color-purple-140"];
            break;
        case "success":
            fontcolor = colors["color-green-160"];
            break;
        case "timestamp":
            fontcolor = colors["color-gray-110"];
            break;
        default:
            fontcolor = colors["color-green-260"];
            break;
    }
    return css `
    color: ${fontcolor};
  `;
}
function getAlertBoxAlignment(variant) {
    switch (variant) {
        case "alert-box-xsmall":
        case "alert-box-order-form":
            return css `
        align-items: center;
      `;
    }
}
//# sourceMappingURL=AlertBox.styled.js.map